import React, { PropTypes } from 'react';
import GrayPanel from '../../components/GrayPanel';
import { PanelStyle } from '../../constants';
import Select from 'react-select';

const {
  leftCol,
  labelCol,
  inputCol,
  inputColExpanded,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
  type,
} = PanelStyle;

const expandedTypes = ['expandedtextarea', 'expandedinput',  'YesOrNo'];

class Decision extends React.Component {
  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  state = {
    tag: 'input',
  };

  renderTextArea = (v, idx) => {
    return (
      <textarea
        id={`field_${v}_${idx}`}
        rows={5}
        name={v}
        style={{
          ...inputStyle,
          borderColor:
            Object.keys(this.props.errors).indexOf(v) > -1 &&
            this.props.errors[v] !== null &&
            this.props.errors[v].length > 0
              ? 'red'
              : '#ccc',
        }}
        className="form-control"
        value={this.props.data[v] ? this.props.data[v] : ''}
        onChange={this.props.onChange}
        placeholder={this.props.formDict[v].placeholder ? this.props.formDict[v].placeholder : ""}
      />
    );
  }

  renderInput = (v, idx) => {
    return (
      <input
        id={`field_${v}_${idx}`}
        type='text'
        name={v}
        style={{
          ...inputStyle,
          borderColor:
            Object.keys(this.props.errors).indexOf(v) > -1 &&
            this.props.errors[v] !== null &&
            this.props.errors[v].length > 0
              ? 'red'
              : '#ccc',
        }}
        className="form-control"
        value={this.props.data[v] ? this.props.data[v] : ''}
        onChange={this.props.onChange}
        placeholder={this.props.formDict[v].placeholder ? this.props.formDict[v].placeholder : ""}
      />
    );
  }

  renderRadioButtons = (v) => {
    return (
      <div>
        <div key={`radio${v}_begin_col`} className='col-sm-4' style={{ marginBottom: '0px', marginTop: '0px' }}></div>
        {this.props.formDict[v].options.map((item, index) => (
          <div key={`radio${item}_${index}`} className='col-sm-2' style={{ marginBottom: '0px', marginTop: '0px' }}>
            <label
              htmlFor={`radio${item}_${index}`}
              style={item.disabled ? { color: 'gray' } : null}
            >
              <input
                id={`radio${item}_${index}`}
                type="radio"
                value={item.value}
                name={v}
                checked={this.props.data[v] === item.value}
                onChange={this.props.onChange}
                disabled={item.disabled}
              />
              <b>{`    ${item.label}`}<br /></b>
            </label>
          </div>
        ))}
        <div key={`radio${v}_end_col`} className='col-sm-4' style={{ marginBottom: '0px', marginTop: '0px' }}></div>
      </div>);
  }

  render() {

    return (
      <GrayPanel title={this.props.title}>
        {this.props.explain_text ? this.props.explain_text() : null}

        {Object.keys(this.props.formDict).map((v, i) => {
          const isEditable =
            this.props.formDict[v].editable && this.props.formDict[v].editable === true;
          const TagName =
            Object.keys(this.props.formDict[v]).indexOf('type') && this.props.formDict[v].type !== undefined ?
            this.props.formDict[v].type : 'input';
          return (
            expandedTypes.includes(TagName) ?
              <div className="row mobile-row" key={i} style={rowStyle}>
                <div className={this.props.leftCol ? this.props.leftCol : leftCol} />
                <div className={this.props.inputColExpanded ? this.props.inputColExpanded : inputColExpanded}>
                  <label style={{ ...labelStyle, textAlign: 'left' }} htmlFor={`field_${v}_${i}`}>{this.props.formDict[v].label}</label>
                </div>
                <div className={this.props.rightCol ? this.props.rightCol : rightCol} />
                <div className={this.props.leftCol ? this.props.leftCol : leftCol} />
                <div className={this.props.inputColExpanded ? this.props.inputColExpanded : inputColExpanded}>
                  {TagName === 'expandedtextarea' ? this.renderTextArea(v, i) : null}
                  {TagName === 'expandedinput' ? this.renderInput(v, i) : null}
                  {TagName === 'YesOrNo' ? this.renderRadioButtons(v) : null}
                  {/* RENDER ERROS IN SPAN */}
                  {Object.keys(this.props.errors).indexOf(v) > -1 &&
                  this.props.errors[v] !== null &&
                  this.props.errors[v].length > 0
                    ? this.props.errors[v].map((val, index) => (
                      <span key={index} style={errorSpanStyle}>
                        {val}
                      </span>
                      ))
                    : null}
                </div>
                <div className={this.props.rightCol ? this.props.rightCol : rightCol} />
              </div>
            :
              <div className="row mobile-row" key={i} style={rowStyle}>
                <div className={this.props.leftCol ? this.props.leftCol : leftCol} />
                <div className={this.props.labelCol ? this.props.labelCol : labelCol}>
                  <label style={labelStyle} htmlFor={`field_${v}_${i}`}>{this.props.formDict[v].label}</label>
                </div>
                <div className={this.props.inputCol ? this.props.inputCol : inputCol}>
                  {isEditable ? (
                    TagName === 'Select' ?
                      <Select
                        id={`field_${v}_${i}`}
                        placeholder="Wybierz z listy..."
                        name="option"
                        value={this.props.data[v] !== '' ? this.props.data[v] : ''}
                        options={this.props.formDict[v].options}
                        clearable={false}
                        // onInputChange={this.inputAdressChange}
                        onChange={this.props.onChangeSelect}
                        noResultsText={'brak wyników'}
                        style={{
                          borderColor:
                          Object.keys(this.props.errors).indexOf(v) > -1 &&
                          this.props.errors[v] !== null &&
                          this.props.errors[v].length > 0
                            ? 'red'
                            : '#ccc',
                        }}
                        onBlur={event => event.preventDefault()}
                        optionClassName="needsclick"
                        blurInputOnSelect={false}
                      />
                            :
                            <TagName
                              id={`field_${v}_${i}`}
                              type={this.props.formDict[v].type ? this.props.formDict[v].type : type}
                              name={v}
                              rows={this.props.formDict[v].rows ? this.props.formDict[v].rows : null}
                              style={{
                                ...inputStyle,
                                borderColor:
                                  Object.keys(this.props.errors).indexOf(v) > -1 &&
                                  this.props.errors[v] !== null &&
                                  this.props.errors[v].length > 0
                                    ? 'red'
                                    : '#ccc',
                              }}
                              className="form-control"
                              value={this.props.data[v] ? this.props.data[v] : ''}
                              onChange={this.props.onChange}
                              placeholder={this.props.formDict[v].placeholder ? this.props.formDict[v].placeholder : ""}
                            />
                  ) : (
                    <input
                      id={`field_${v}_${i}`}
                      name={v}
                      style={{
                        ...inputStyle,
                        borderColor:
                          Object.keys(this.props.errors).indexOf(v) > -1 &&
                          this.props.errors[v] !== null &&
                          this.props.errors[v].length > 0
                            ? 'red'
                            : '#ccc',
                      }}
                      className="form-control"
                      value={this.props.data[v] ? this.props.data[v] : ''}
                      disabled
                    />
                  )}

                  {/* RENDER ERROS IN SPAN */}
                  {Object.keys(this.props.errors).indexOf(v) > -1 &&
                  this.props.errors[v] !== null &&
                  this.props.errors[v].length > 0
                    ? this.props.errors[v].map((val, index) => (
                      <span key={index} style={errorSpanStyle}>
                        {val}
                      </span>
                      ))
                    : null}
                </div>
                <div className={this.props.rightCol ? this.props.rightCol : rightCol} />
              </div>
          );
        })}
        {this.props.children}
      </GrayPanel>
    );
  }
}

Decision.PropTypes = {
  children: PropTypes.Object,
  rightCol: PropTypes.Object,
  labelCol: PropTypes.Object,
  leftCol: PropTypes.Object,
  explain_text: PropTypes.func,
  title: PropTypes.string,
  formDict: PropTypes.Object,
};

export default Decision;



// WEBPACK FOOTER //
// src/containers/Decision/index.jsx